module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "center "
  }, [_vm._v("© by José Saramago, 1990")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("English translation © Amanda Hopkinson and Nick Caistor, 2000")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopy, recording, or any information storage and retrieval system, without permission in writing from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_c('a', {
    attrs: {
      "href": "https://hmhbooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("hmhbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("This is a translation of "), _c('em', [_vm._v("Viagem a Portugal")])]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("The maps have been drawn by Reginald Piggott")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("The Library of Congress has cataloged the print edition as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Saramago, José"), _c('br'), _vm._v("\n[Viagem a Portugal. English]")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Journey to Portugal/José Saramago: translated from the Portuguese and with notes by Amanda Hopkinson and Nick Caistor.—1st U.S. ed.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("p. cm."), _c('br'), _vm._v("\nIncludes index.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 0-15-100587-7")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 0-15-600713-4 (pbk.)")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("1. Portugal—Description and travel. I. Hopkinson, Amanda, 1948–"), _c('br'), _vm._v("\nII. Caistor, Nick. III. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("DP526.5 .S2713 2001"), _c('br'), _vm._v("\n914.6904'44—dc21 00-053613")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("e"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-547-54104-4"), _c('br'), _vm._v("\nv3.0621")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d48f4458","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 60
// module chunks = 0